import { render, staticRenderFns } from "./ProductStoreStockQtyUpdate.vue?vue&type=template&id=65840bb2&scoped=true&"
import script from "./ProductStoreStockQtyUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductStoreStockQtyUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProductStoreStockQtyUpdate.vue?vue&type=style&index=0&id=65840bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65840bb2",
  null
  
)

export default component.exports